"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORAGE_KEY = exports.PLACEHOLDER_DOT_INDENTATION = exports.HOVER_EXPAND_WAITING = exports.COLLAPSED_ICON_INDENTATION = void 0;
var COLLAPSED_ICON_INDENTATION = exports.COLLAPSED_ICON_INDENTATION = 24;
var PLACEHOLDER_DOT_INDENTATION = exports.PLACEHOLDER_DOT_INDENTATION = 3; // indent for placeholder dot

// Waiting time when hovering a collapsed parent before expanding
var HOVER_EXPAND_WAITING = exports.HOVER_EXPAND_WAITING = 1000;
var STORAGE_KEY = exports.STORAGE_KEY = 'nestedSortable';